import React, { useMemo } from 'react';

import PocketGofCountDown from './GOF/Countdown';
import PocketGofFeaturing from './GOF/Featuring';
import PocketGofStreams from './GOF/Streams';
import PocketGofTournaments from './GOF/Tournaments';
import PocketBreakingNews from './P1/BreakingNews';
import PocketHighlights from './P1/Highlights';
import PocketMailingList from './P1/MailingList';
import PocketMainGMR from './P1/MainGMR';
import PocketMainMRG from './P1/MainMRG';
import BannerFeedItemDesktop from './VKP/BannerFeedItemDesktop';
import BannerFeedItemMobile from './VKP/BannerFeedItemMobile';
import BannerRight from './VKP/BannerRight';
import PocketGamesVKP from './VKP/Games';
import PocketMainVKP from './VKP/Main';

export default function PocketsManager({ match }) {
    const pocket = useMemo(() => {
        const { pocket, param } = match?.params;

        if (pocket === 'main-mrg') {
            return <PocketMainMRG />;
        }

        if (pocket === 'main-gmr') {
            return <PocketMainGMR />;
        }

        if (pocket === 'main-vkplay') {
            return <PocketMainVKP />;
        }

        if (pocket.includes('-games')) {
            return <PocketGamesVKP type={pocket.split('-')[0]} />;
        }

        if (pocket === 'highlights-vkplay') {
            return <PocketHighlights />;
        }

        if (pocket === 'breaking') {
            return <PocketBreakingNews project={param} />;
        }

        if (pocket === 'mailing_list_vkplay') {
            return <PocketMailingList type={pocket} />;
        }

        if (pocket === 'banner-right') {
            return <BannerRight project={param} />;
        }

        if (pocket.includes('commercial-desktop')) {
            return <BannerFeedItemDesktop project={param} />;
        }

        if (pocket.includes('commercial-mobile')) {
            return <BannerFeedItemMobile project={param} />;
        }

        if (pocket === 'gof-streams') {
            return <PocketGofStreams />;
        }

        if (pocket === 'gof-countdown') {
            return <PocketGofCountDown />;
        }

        if (pocket === 'gof-featuring') {
            return <PocketGofFeaturing lang={param} />;
        }

        if (pocket === 'gof-tournaments') {
            return <PocketGofTournaments />;
        }

        return null;
    }, [match]);

    return pocket;
}
